module.exports = __webpack_public_path__ + "svg/bg-traiangle-2.svg";